import { AgwApiClient } from "./api-client";

export * from "./types/radio";

export const agwApiClient = new AgwApiClient();
